import React from "react";
import { RenderKilogramo } from "../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../Utils/renderField/nullableValue";

export const ProductosTable = ({ trasladoDetalle }) => {
    return (
        <div className="new-table-wrapper recepcion-traslado__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>RECEPCIONES</th>
                        <th>MATERIA PRIMA</th>
                        <th>KILOS HÚMEDOS</th>
                        <th>KILOS SECOS LAB</th>
                        <th className="cell-border-left">PESO NETO REAL</th>
                    </tr>
                </thead>
                <tbody>
                    {trasladoDetalle &&
                        trasladoDetalle.detalles &&
                        trasladoDetalle.detalles.map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td className="text-center text-nowrap recepcion-traslado__table-ellipsis-cell">
                                        {item.ingresos_ids_concat}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.materia_prima
                                            ? item.materia_prima.nombre
                                            : ""}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue
                                            value={item.kilos_humedos}
                                        >
                                            <RenderKilogramo
                                                value={item.kilos_humedos}
                                                decimalScale={2}
                                            />
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue
                                            value={item.kilos_secos_laboratorio}
                                        >
                                            <RenderKilogramo
                                                value={
                                                    item.kilos_secos_laboratorio
                                                }
                                                decimalScale={3}
                                            />
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap cell-border-left">
                                        {item.yaPesado ? (
                                            <RenderKilogramo
                                                value={item.pesaje.peso_neto}
                                            />
                                        ) : (
                                            "—"
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
};
